export const whitelistedEndpoints = [
    'https://bo.wix.com/suricate/tunnel/',
    'https://localhost:',
    'http://localhost:',
    'https://sled.wix.dev/',
    'https://static.parastorage.com/',
];
const isAllowedHostRegexp = new RegExp(`^((${whitelistedEndpoints.join(')|(')}))`);
export function validateLibraryURL(url) {
    return isAllowedHostRegexp.test(url);
}
//# sourceMappingURL=validateLibraryURL.js.map